import request from '@/libs/request';
import config from '@/config';
const baseUrl = config.api_base;

/**
 * 设备模型列表
 * @param {*} params
 * @returns
 */
export const DeviceModelListAll = params => {
  return request('get', `${baseUrl}/api/auth/sys/dev/model/all`, params);
};

/**
 * 根据站点获取设备模型列表
 * @param {*} params
 * @returns
 */
export const DeviceModelListAllByStation = params => {
  return request('get', `${baseUrl}/api/auth/sys/dev/model/station/list`, params);
};

/**
 * 新增设备模型
 */
export const DeviceModelAdd = data => {
  return request('post', `${baseUrl}/api/auth/sys/dev/model/add`, data);
};

/**
 * Fork新模型
 * @param {*} data
 * @returns
 */
export const DeviceModelFork = data => {
  return request('post', `${baseUrl}/api/auth/sys/dev/model/fork`, data);
};

/**
 * 设备模型基础信息
 * @param {*} params
 * @returns
 */
export const DeviceModelDetail = params => {
  return request('get', `${baseUrl}/api/auth/sys/dev/model/detail`, params);
};

/**
 * 编辑设备模型
 */
export const DeviceModelEdit = data => {
  return request('post', `${baseUrl}/api/auth/sys/dev/model/edit`, data);
};

/**
 * 删除设备模型
 */
export const DeviceModelDelete = data => {
  return request('post', `${baseUrl}/api/auth/sys/dev/model/del`, data);
};

/**
 * 新增设备模型配置
 */
export const DeviceConfigAdd = data => {
  return request('post', `${baseUrl}/api/auth/sys/dev/model/cfg/add`, data);
};

/**
 * 删除设备模型配置{apiNoUse}
 */
export const DeviceConfigDelete = data => {
  return request('post', `${baseUrl}/api/auth/sys/dev/model/cfg/del`, data);
};

/**
 * 批量删除设备模型配置
 */
export const DeviceConfigDeleteBatch = data => {
  return request('post', `${baseUrl}/api/auth/sys/dev/model/cfg/del/batch`, data);
};

/**
 * 编辑设备模型配置
 */
export const DeviceConfigEdit = data => {
  return request('post', `${baseUrl}/api/auth/sys/dev/model/cfg/edit`, data);
};

/**
 * 设备模型配置详情信息{apiNoUse}
 * @param {*} params
 * @returns
 */
export const DeviceConfigDetail = params => {
  return request('get', `${baseUrl}/api/auth/sys/dev/model/cfg/get`, params);
};

/**
 * 获取指定设备模型的配置信息列表
 * @param {*} params
 * @returns
 */
export const DeviceConfigList = params => {
  return request('get', `${baseUrl}/api/auth/sys/dev/model/cfg/list`, params);
};

/**
 * 获取所属子模型列表
 * @param {*} params
 * @returns
 */
export const DeviceConfigChildList = params => {
  return request('get', `${baseUrl}/api/auth/sys/dev/model/child`, params);
};

/**
 * 新增设备模型参数
 */
export const DeviceModelParamAdd = data => {
  return request('post', `${baseUrl}/api/auth/sys/dev/model/param/add`, data);
};

/**
 * 删除设备模型参数{apiNoUse}
 */
export const DeviceModelParamDelete = data => {
  return request('post', `${baseUrl}/api/auth/sys/dev/model/param/del`, data);
};

/**
 * 批量删除设备模型参数
 */
export const DeviceModelParamDeleteBatch = data => {
  return request('post', `${baseUrl}/api/auth/sys/dev/model/param/del/batch`, data);
};

/**
 * 编辑设备模型参数
 */
export const DeviceModelParamEdit = data => {
  return request('post', `${baseUrl}/api/auth/sys/dev/model/param/edit`, data);
};

/**
 * 设备模型参数详情信息{apiNoUse}
 * @param {*} params
 * @returns
 */
export const DeviceModelParamDetail = params => {
  return request('get', `${baseUrl}/api/auth/sys/dev/model/param/get`, params);
};

/**
 * 获取指定设备模型的参数信息列表
 * @param {*} params
 * @returns
 */
export const DeviceModelParamList = params => {
  return request('get', `${baseUrl}/api/auth/sys/dev/model/param/list`, params);
};

/**
 * 设备模型选择{apiNoUse}
 * @param {*} params
 * @returns
 */
export const DeviceModelSelectList = params => {
  return request('get', `${baseUrl}/api/auth/sys/dev/model/select`, params);
};

/**
 * 新增设备模型控制
 */
export const DeviceModelControlAdd = params => {
  return request('POST', `${baseUrl}/api/auth/sys/dev/model/ctrl/add`, params);
};

/**
 * 所有设备模型控制{apiNoUse}
 */
export const DeviceModelControlAll = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/model/ctrl/all`, params);
};

/**
 * 删除设备模型控制{apiNoUse}
 */
export const DeviceModelControlDelete = params => {
  return request('POST', `${baseUrl}/api/auth/sys/dev/model/ctrl/del`, params);
};
/**
 * 批量删除设备模型控制
 */
export const DeviceModelControlDeleteBatch = params => {
  return request('POST', `${baseUrl}/api/auth/sys/dev/model/ctrl/del/batch`, params);
};
/**
 * 编辑设备模型控制
 */
export const DeviceModelControlEdit = params => {
  return request('POST', `${baseUrl}/api/auth/sys/dev/model/ctrl/edit`, params);
};
/**
 * 设备模型控制详情信息{apiNoUse}
 */
export const DeviceModelControlDetail = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/model/ctrl/get`, params);
};
/**
 * 设备模型控制详情信息
 */
export const DeviceModelControlList = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/model/ctrl/list`, params);
};

/**
 * 获取设备模型头像列表
 */
export const DeviceModelAvatarList = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/model/avatar/list`, params);
};

/**
 * 获取设备模型的别名列表
 */
export const DeviceModelAliasList = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/model/alias/list`, params);
};

/**
 * 获取设备模型的别名 - 更新
 */
export const DeviceModelAliasUpdates = params => {
  return request('POST', `${baseUrl}/api/auth/sys/dev/model/alias/updates`, params);
};

/**
 * 获取设备模型的别名 - 删除多个
 */
export const DeviceModelAliasChildDels = params => {
  return request('POST', `${baseUrl}/api/auth/sys/dev/model/alias/child/dels`, params);
};

/**
 * 获取设备模型的别名 - 删除单个
 */
export const DeviceModelAliasChildDel = params => {
  return request('POST', `${baseUrl}/api/auth/sys/dev/model/alias/child/del`, params);
};

/**
 * 使用获取设备模型的别名
 * @param {*} params
 * @returns
 */
export const DeviceModelAliasGet = params => {
  return request('GET', `${baseUrl}/api/auth/sys/dev/model/alias/sync`, params);
};
